import React from "react"

const Filter = props => (
  <div className="Filter">
    <div className="FilterBy">
      <h4 className="FilterTitle">{props.filterTitle}</h4>{" "}
      <span className="FilterClose">Clear</span>
    </div>
    {props.catagorys}
  </div>
)

export default Filter
